import * as React from 'react';

import { Button } from 'components/bootstrap';
import { Icon } from 'components/common';

type Props = {
  onClick: () => void;
  disabled?: boolean;
  title: string;
};

const PlusButton = ({ onClick, disabled = false, title }: Props) => (
  <Button bsSize="small" onClick={onClick} disabled={disabled}>
    <Icon name="add" /> {title}
  </Button>
);

export default PlusButton;
